<template>
  <div class="container print-releases-by-profit-cost-center">
    <ErrorsMessages :errors="errors" />
    <div
      v-show="pay.length > 0 || receive.length > 0"
      class="text-right mb-2 btn-print-releases-by-profit-cost-center"
    >
      <v-btn class="btn-print" @click="handlePrint"
        ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
      >
    </div>
    <table class="bg-white" v-if="receive.length > 0">
      <thead>
        <tr>
          <td>
            <div class="header-space">
              <div style="page-break-after: always !important">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <div>
                      <img
                        style="
                          height: 80px !important;
                          object-fit: cover !important;
                        "
                        v-if="rest_home_logo_url"
                        class="rest_home_logo_url"
                        :src="rest_home_logo_url"
                      />
                      <div v-if="!rest_home_logo_url" class="ml-1">
                        <strong class="text-uppercase">{{
                          rest_home_name
                        }}</strong>
                      </div>
                    </div>
                    <div class="ml-5">
                      <b style="font-size: 28px !important">
                        {{ rest_home_fantasy_name }}
                      </b>
                      <div>
                        <p class="m-0">
                          Regime de
                          {{
                            cash_competence == "cash" ? "Caixa" : "Competência"
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    <img
                      width="150px"
                      height="30px"
                      :src="require('../../../../assets/logo.png')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div class="content">
              <b-overlay :show="loading" opacity="0.99">
                <div
                  class="v-clean p-5 text-center"
                  v-show="pay.length == 0 && receive.length == 0"
                >
                  <h6 class="text-center upper-text worksansr">
                    SEM RESULTADOS!
                  </h6>
                </div>
                <div
                  v-if="receive.length > 0"
                  class="page-break-before-always content-page"
                >
                  <h4>Receitas</h4>
                  <div class="">
                    <GChart
                      :settings="{ packages: ['corechart'] }"
                      type="PieChart"
                      :data="dataReceive"
                      :options="{
                        pieHole: 0.4,
                        height: 400,
                      }"
                    />
                  </div>
                  <div
                    v-for="(item, key) in receive"
                    :key="key"
                    class="row m-0 border-bottom page-break-inside-avoid"
                  >
                    <div class="col-md-8 d-flex align-items-center p-0">
                      <span class="ml-2">{{ item.description }}</span>
                    </div>
                    <div class="col-md-4 p-0 text-right">
                      <span class="c-success">
                        {{ formatMoney(String(item.total)) }}</span
                      >
                      <small class="ml-2">({{ item.percentage }}%)</small>
                    </div>
                  </div>
                  <div class="row m-0">
                    <div class="col-md-8 p-0"><b>Total</b></div>
                    <div class="col-md-4 p-0 c-success text-right">
                      {{ formatMoney(String(total_receive)) }}
                    </div>
                  </div>
                </div>
              </b-overlay>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="bg-white" v-if="pay.length > 0">
      <thead>
        <tr>
          <td>
            <div class="header-space">
              <div style="page-break-after: always !important">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <div>
                      <img
                        style="
                          height: 80px !important;
                          object-fit: cover !important;
                        "
                        v-if="rest_home_logo_url"
                        class="rest_home_logo_url"
                        :src="rest_home_logo_url"
                      />
                      <div v-if="!rest_home_logo_url" class="ml-1">
                        <strong class="text-uppercase">{{
                          rest_home_name
                        }}</strong>
                      </div>
                    </div>
                    <div class="ml-5">
                      <b style="font-size: 28px !important">
                        {{ rest_home_fantasy_name }}
                      </b>
                      <div>
                        <p class="m-0">
                          Regime de
                          {{
                            cash_competence == "cash" ? "Caixa" : "Competência"
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex">
                    <img
                      width="150px"
                      height="30px"
                      :src="require('../../../../assets/logo.png')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div class="content">
              <b-overlay :show="loading" opacity="0.99">
                <div class="page-break-before-always content-page">
                  <h4>Despesas</h4>
                  <div class="">
                    <GChart
                      :settings="{ packages: ['corechart'] }"
                      type="PieChart"
                      :data="dataPay"
                      :options="{
                        pieHole: 0.4,
                        height: 400,
                      }"
                    />
                  </div>
                  <div
                    v-for="(item, key) in pay"
                    :key="key"
                    class="row m-0 border-bottom"
                  >
                    <div class="col-md-8 d-flex align-items-center p-0">
                      <span class="ml-2">{{ item.description }}</span>
                    </div>
                    <div class="col-md-4 p-0 text-right">
                      <span class="c-danger"
                        >-{{ formatMoney(String(item.total)) }}</span
                      >
                      <small class="ml-2">({{ item.percentage }}%)</small>
                    </div>
                  </div>
                  <div class="row m-0">
                    <div class="col-md-8 p-0"><b>Total</b></div>
                    <div class="col-md-4 p-0 c-danger text-right">
                      -{{ formatMoney(String(total_pay)) }}
                    </div>
                  </div>
                </div>
              </b-overlay>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="bg-white content-page-result">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <div>
            <img
              style="height: 80px !important; object-fit: cover !important"
              v-if="rest_home_logo_url"
              class="rest_home_logo_url"
              :src="rest_home_logo_url"
            />
            <div v-if="!rest_home_logo_url" class="ml-1">
              <strong class="text-uppercase">{{ rest_home_name }}</strong>
            </div>
          </div>
          <div class="ml-5">
            <b style="font-size: 28px !important">
              {{ rest_home_fantasy_name }}
            </b>
            <div>
              <p class="m-0">
                Regime de
                {{ cash_competence == "cash" ? "Caixa" : "Competência" }}
              </p>
            </div>
          </div>
        </div>
        <div class="d-flex">
          <img
            width="150px"
            height="30px"
            :src="require('../../../../assets/logo.png')"
          />
        </div>
      </div>
      <b-overlay :show="loading" opacity="0.99">
        <div class="content-page">
          <h4 class="text-center">Resumo do período</h4>
          <div class="d-flex align-items-center justify-content-center">
            <p class="m-0 worksansr">Total de ganhos:</p>
            <p class="ml-2 m-0 c-success">
              {{ formatMoney(String(total_receive)) }}
            </p>
          </div>
          <div class="d-flex align-items-center justify-content-center">
            <p class="m-0 worksansr">Total de gastos:</p>
            <p class="ml-2 m-0 c-danger">
              -{{ formatMoney(String(total_pay)) }}
            </p>
          </div>
          <div class="d-flex align-items-center justify-content-center">
            <p class="m-0 worksansr">Resultado do período:</p>
            <p
              :class="[
                'ml-2 m-0',
                period_result >= 0 && 'c-success',
                period_result < 0 && 'c-danger',
              ]"
            >
              {{ formatMoney(String(period_result)) }}
            </p>
          </div>
          <div class="text-center">
            <hr class="m-0" />
            (Assinatura eletrônica)
            {{
              professionalClassCouncilValue({
                id: user.professional_class_council_id,
                name: user.name,
                profile: user.profile_name,
                cpf: user.cpf,
                office: user.office,
                value: user.professional_class_council_value,
              })
            }}
            <small> - {{ moment().format("DD/MM/YYYY HH:mm:ss") }} </small>
          </div>
        </div>
      </b-overlay>
    </div>
    <div
      v-show="pay.length > 0 || receive.length > 0"
      class="text-right mt-2 btn-print-releases-by-profit-cost-center"
    >
      <v-btn class="btn-print" @click="handlePrint"
        ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
      >
    </div>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts";

import ErrorsMessages from "../../../Components/ErrorsMessages";

import api from "../../../../services/api";

import routes from "../../../../routes";

import {
  formatMoney,
  professionalClassCouncilValue,
} from "../../../../lib/format";

import moment from "moment";

import { userData } from "../../../../lib/functions";

export default {
  name: "PrintReleasesByProfitCostCenter",
  components: {
    GChart,
    ErrorsMessages,
  },
  data() {
    return {
      user: {},
      chartsLib: null,
      dataReceive: [["CATEGORIA", "QUANTIDADE"]],
      dataPay: [["CATEGORIA", "QUANTIDADE"]],
      pay: [],
      total_pay: 0,
      receive: [],
      total_receive: 0,
      period_result: 0,
      max_progress: 100,

      start_date: moment().format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
      filter_by_period: false,
      cash_competence: "cash",
      month: moment().format("YYYY-MM-DD"),
      dayMonthYear: "month",
      account_ids: [],
      types_of_entries_ids: [],
      users_ids: [],
      provider_ids: [],
      finance_client_ids: [],
      finance_configuration_document_types_ids: [],
      finance_configuration_payment_methods_ids: [],
      finance_configuration_category_ids: [],
      finance_configuration_profit_cost_center_ids: [],
      finance_configuration_tag_ids: [],
      cost_types_ids: [],
      cost_appropriations_ids: [],

      loading: false,
      errors: [],
    };
  },
  async created() {
    let {
      cash_competence,
      month,
      dayMonthYear,
      account_ids,
      types_of_entries_ids,
      users_ids,
      provider_ids,
      finance_client_ids,
      finance_configuration_document_types_ids,
      finance_configuration_payment_methods_ids,
      finance_configuration_category_ids,
      finance_configuration_profit_cost_center_ids,
      finance_configuration_tag_ids,
      cost_types_ids,
      cost_appropriations_ids,
      filter_by_period,
      start_date,
      end_date,
    } = routes.currentRoute.params;

    if (
      !cash_competence ||
      !month ||
      !dayMonthYear ||
      !account_ids ||
      !types_of_entries_ids ||
      !users_ids ||
      !provider_ids ||
      !finance_client_ids ||
      !finance_configuration_document_types_ids ||
      !finance_configuration_payment_methods_ids ||
      !finance_configuration_category_ids ||
      !finance_configuration_profit_cost_center_ids ||
      !finance_configuration_tag_ids ||
      !cost_types_ids ||
      !cost_appropriations_ids ||
      !filter_by_period ||
      !start_date ||
      !end_date
    ) {
      routes.push({ name: "dashboard" });
      return;
    }

    this.cash_competence = cash_competence;
    this.month = month;
    this.dayMonthYear = dayMonthYear;
    this.account_ids = account_ids.split(",");
    this.types_of_entries_ids =
      types_of_entries_ids != "false" ? types_of_entries_ids.split(",") : [];
    this.users_ids = users_ids != "false" ? users_ids.split(",") : [];
    this.provider_ids = provider_ids != "false" ? provider_ids.split(",") : [];
    this.finance_client_ids =
      finance_client_ids != "false" ? finance_client_ids.split(",") : [];
    this.finance_configuration_document_types_ids =
      finance_configuration_document_types_ids != "false"
        ? finance_configuration_document_types_ids.split(",")
        : [];
    this.finance_configuration_payment_methods_ids =
      finance_configuration_payment_methods_ids != "false"
        ? finance_configuration_payment_methods_ids.split(",")
        : [];
    this.finance_configuration_category_ids =
      finance_configuration_category_ids != "false"
        ? finance_configuration_category_ids.split(",")
        : [];
    this.finance_configuration_profit_cost_center_ids =
      finance_configuration_profit_cost_center_ids != "false"
        ? finance_configuration_profit_cost_center_ids.split(",")
        : [];
    this.finance_configuration_tag_ids =
      finance_configuration_tag_ids != "false"
        ? finance_configuration_tag_ids.split(",")
        : [];
    this.cost_types_ids =
      cost_types_ids != "false" ? cost_types_ids.split(",") : [];
    this.cost_appropriations_ids =
      cost_appropriations_ids != "false"
        ? cost_appropriations_ids.split(",")
        : [];
    this.filter_by_period = filter_by_period;
    this.start_date = start_date;
    this.end_date = end_date;

    let {
      user: { rest_home_name, rest_home_fantasy_name, logo_url },
    } = userData();

    this.user = userData().user;
    this.rest_home_name = rest_home_name;
    this.rest_home_fantasy_name = rest_home_fantasy_name;
    this.rest_home_logo_url = logo_url;

    await this.get();
  },
  methods: {
    moment,
    formatMoney,
    professionalClassCouncilValue,
    async get() {
      try {
        this.loading = true;

        this.dataReceive = [["CATEGORIA", "QUANTIDADE"]];
        this.dataPay = [["CATEGORIA", "QUANTIDADE"]];

        let {
          cash_competence,
          month,
          dayMonthYear,
          account_ids,
          types_of_entries_ids,
          users_ids,
          provider_ids,
          finance_client_ids,
          finance_configuration_document_types_ids,
          finance_configuration_payment_methods_ids,
          finance_configuration_category_ids,
          finance_configuration_profit_cost_center_ids,
          finance_configuration_tag_ids,
          cost_types_ids,
          cost_appropriations_ids,
          filter_by_period,
          start_date,
          end_date,
        } = this;

        let params = {
          cash_competence,
          month,
          dayMonthYear,
          account_ids,
          types_of_entries_ids,
          users_ids,
          provider_ids,
          finance_client_ids,
          finance_configuration_document_types_ids,
          finance_configuration_payment_methods_ids,
          finance_configuration_category_ids,
          finance_configuration_profit_cost_center_ids,
          finance_configuration_tag_ids,
          cost_types_ids,
          cost_appropriations_ids,
          filter_by_period,
          start_date,
          end_date,
        };

        const response = await api.get(
          "/rest-home/financial/reports/releases-by-profit-cost-center",
          { params }
        );

        const { error, errors, pay, total_pay, receive, total_receive } =
          response.data;

        if (error) {
          this.errors = errors;
          this.receive = [];
          this.total_receive = 0;
          this.pay = [];
          this.total_pay = 0;
          this.max_progress = 0;
          this.period_result = 0;
        } else {
          this.errors = [];
          let pays = [];
          let receives = [];

          for (let item of receive) {
            if (item.total > 0) {
              let total = item.total;
              let init = String(total).substr(0, String(total).length - 2);
              let end = String(total).substr(String(total).length - 2, 2);
              this.dataReceive.push([
                item.description,
                parseFloat(`${init}.${end}`),
              ]);
              let percentage = (item.total * 100) / total_receive;
              percentage = percentage.toFixed(2);
              receives.push({ ...item, percentage });
            }
          }

          for (let item of pay) {
            if (item.total > 0) {
              let total = item.total;
              let init = String(total).substr(0, String(total).length - 2);
              let end = String(total).substr(String(total).length - 2, 2);
              this.dataPay.push([
                item.description,
                parseFloat(`${init}.${end}`),
              ]);
              let percentage = (item.total * 100) / total_pay;
              percentage = percentage.toFixed(2);
              pays.push({ ...item, percentage });
            }
          }

          this.receive = receives;
          this.total_receive = total_receive;
          this.pay = pays;
          this.total_pay = total_pay;

          if (parseFloat(total_pay) >= parseFloat(total_receive)) {
            this.max_progress = total_pay;
          } else {
            this.max_progress = total_receive;
          }

          this.period_result =
            parseFloat(total_receive) - parseFloat(total_pay);
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    handlePrint() {
      window.print();
    },
  },
};
</script>

<style>
.print-releases-by-profit-cost-center .header,
.print-releases-by-profit-cost-center .header-space {
  height: 120px;
}

.print-releases-by-profit-cost-center .header {
  position: fixed;
  top: 0;
}

.print-releases-by-profit-cost-center table {
  width: 100% !important;
  cursor: auto !important;
}

.print-releases-by-profit-cost-center .logo {
  height: 50px;
  object-fit: contain;
}
.print-releases-by-profit-cost-center .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}

.print-releases-by-profit-cost-center .content-page {
  padding: 20px !important;
}

@media print {
  * {
    background: transparent !important;
    color: #000 !important;
    text-shadow: none !important;
    filter: none !important;
    -ms-filter: none !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .print-releases-by-profit-cost-center table {
    page-break-before: always !important;
  }

  .print-releases-by-profit-cost-center .content-page-result {
    page-break-before: always !important;
  }

  .print-releases-by-profit-cost-center .content-page-result {
    width: 100% !important;
  }

  .print-releases-by-profit-cost-center .content-page {
    padding: 20px !important;
  }

  .print-releases-by-profit-cost-center .page-break-before-always {
    page-break-before: always !important;
  }

  .print-releases-by-profit-cost-center .page-break-inside-avoid {
    page-break-inside: avoid !important;
  }

  .print-releases-by-profit-cost-center
    .btn-print-releases-by-profit-cost-center {
    display: none;
  }
}
</style>